export const enchantement = {
  card_background_color: 'transparent',

  logo_image_url: 'enchantement.png',
  logo_height: 75,
  token_url: 'enchantement.png',
  number_hidden: true,

  body_background_color: 'transparent',
  body_background_image_url: 'foodsociety/orange-blue.png',
  body_background_more: 'center center no-repeat',

  button_color: 'black',
  button_font: `'Open Sans', sans-serif`,
  button_radius: 50,

  text_font: `'Open Sans', sans-serif`,
  text_color: 'black',
  title_font: `'Righteous', cursive`,

  photobooth_button_color: 'white',
  photobooth_button_text_color: 'black',
}

export const enchantement_fullscreen = {
  ...enchantement,

  card_fullscreen: true,
  card_text_centered: true,
  card_header_hidden: true,

  logo_height: 110,
  token_hidden: true,

  text_size: 40,
  text_lineheight: 50,

  subtitle_size: 50,
  subtitle_lineheight: 50,
  subtitle_margin: 40,

  image_margin: 40,

  footer_hidden: true,
}

export const enchantement_secondary = {
  ...enchantement,
  body_background_image_url: 'foodsociety/yellow-teal.png',
}
